import React, { useState } from "react";
import { Typography, Box, Chip, Button, Grid, Tooltip } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { useTheme } from "@mui/material/styles";
import { timeMapping } from "../utils/Constants";
const DEFAULT_DISPLAY_TIME_INDEX = 36;

export const RescheduleSlotsList = ({ onSelectTime, selectedTime }) => {
    const theme = useTheme();

    // Scroll to the index containing the selected time
    const selectedTimeIndex = Object.keys(timeMapping).indexOf(selectedTime);
    const [startIndex, setStartIndex] = useState(() => {
        return selectedTimeIndex >= 0
            ? Math.floor(selectedTimeIndex / 18) * 18
            : DEFAULT_DISPLAY_TIME_INDEX;
    });
    return (
        <Grid container justifyContent={"center"}>
            <Button
                sx={{
                    height: "14px",
                    alignSelf: "flex-start",
                    marginTop: "18px",
                    "&:hover": {
                        backgroundColor: "unset",
                        color: theme.palette.primary.dark
                    }
                }}
                hidden={startIndex === 0}
                onClick={() => {
                    if (startIndex < 18) setStartIndex(0);
                    else setStartIndex(startIndex - 18);
                }}
            >
                <Tooltip title="Show earlier times" placement="top">
                    <KeyboardArrowUpIcon sx={{ fontSize: "24px" }} />
                </Tooltip>
            </Button>
            <Grid
                container
                columnSpacing={2.25}
                rowSpacing={2.25}
                mb="18px"
                justifyContent={"space-between"}
            >
                {Object.keys(timeMapping)
                    .slice(startIndex, startIndex + 18)
                    .map((slotTime, idx) => (
                        <Grid item xs={4} key={idx}>
                            <Slot
                                key={timeMapping[slotTime]}
                                slotTime={slotTime}
                                onSelect={onSelectTime}
                                isSelected={selectedTime === slotTime}
                            />
                        </Grid>
                    ))}
            </Grid>
            <Button
                sx={{
                    height: "14px",
                    alignSelf: "flex-start",
                    "&:hover": {
                        backgroundColor: "unset",
                        color: theme.palette.primary.dark
                    }
                }}
                hidden={startIndex + 18 >= 96}
                onClick={() => {
                    if (startIndex + 18 + 18 >= 96) setStartIndex(96 - 18);
                    else setStartIndex(startIndex + 18);
                }}
            >
                <Tooltip title="Show later times" placement="bottom">
                    <KeyboardArrowDownIcon sx={{ fontSize: "24px" }} />
                </Tooltip>
            </Button>
        </Grid>
    );
};

export const Slot = ({ slotTime, onSelect, isSelected }) => {
    const theme = useTheme();
    return (
        <Chip
            key={slotTime}
            onClick={() => {
                onSelect(timeMapping[slotTime]);
            }}
            variant="smallTimeSuggestions"
            sx={{
                backgroundColor: isSelected
                    ? theme.palette.primary.main
                    : theme.palette.grey.lightest,
                ":hover": {
                    backgroundColor: isSelected
                        ? theme.palette.primary.main
                        : theme.palette.primary.medium
                }
            }}
            label={
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center"
                    }}
                >
                    <Typography
                        variant="body2"
                        gutterBottom={false}
                        sx={{
                            color: isSelected
                                ? "white"
                                : theme.palette.text.main
                        }}
                    >
                        {slotTime}
                    </Typography>
                </Box>
            }
        />
    );
};
